<template>
  <div v-if="hasServiceType">
    <h6 class="text-uppercase grey--text">
      {{ $t('host.label.serviceType') }}
    </h6>
    <div v-for="service in data.service_type" :key="service">
      <span v-html="hostService(service)" />
    </div>
  </div>
</template>

<script>
import { icons } from '@/util/iconsSVG'

export default {
  name: 'HostServices',

  props: {
    data: {
      type: Object,
      required: true,
    }
  },

  computed: {
    hasServiceType() {
      return this.data?.service_type && this.data?.service_type?.length >= 1
    }
  },

  methods: {
    handleGetIcon(type) {
      return icons[type]
    },

    hostService(service) {
      if (!service) return

      return `
        <span class="host-summary-service">
          ${this.handleGetIcon(service)}
          <span>${this.$t(`type.${service}`)}</span>
        </span>
      `
    },
  },
}
</script>

<style>
.host-summary-service {
  display: flex;
  align-items: center;
  margin: 0 0 10px;
}

.host-summary-service svg {
  width: 22px;
  height: 22px;
  margin: 0 5px 0 0;
}
</style>
